import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import {
  MDBCol,
} from "mdbreact";
import { observable } from "mobx";
import { Button, Radio, RadioGroup } from "@blueprintjs/core";
import { AssinaturaStore } from "../../stores/assinatura/AssinaturaStore";
const numeral = require("numeral");

interface Props {
}

interface State {
}

@observer
export class AssinaturaAtivar extends React.Component<Props, State> {

  obs = observable({
    metodo_pagamento: "" as string,
    loading: false as boolean
  })
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    AppStore.setTitle("Ativação da sua Conta")
  }

  handleChangePagamento(value) {
    this.obs.metodo_pagamento = value.target.value
  }

  async handleAssinarPix() {
    this.obs.loading = true

    let params = {
      metodo_pagamento: "pix"
    }
    await AssinaturaStore.handleAtivaPlano(params)

    this.obs.loading = false
  }

  async handleAssinarBoleto() {
    this.obs.loading = true

    let params = {
      metodo_pagamento: "boleto"
    }
    await AssinaturaStore.handleAtivaPlano(params)

    this.obs.loading = false
  }

  async handleAssinarCartao() {
    this.obs.loading = true

    let params = {
      metodo_pagamento: "cartao"
    }
    await AssinaturaStore.handleAtivaPlano(params)

    this.obs.loading = false
  }

  render() {

    const handleGetDesconto = () => {

      let valor = 200 - AppStore.obs1.usuario.conta.desconto

      if (valor < 0) {
        valor = 0
      }

      const desconto = ((200 - valor) / 200) * 100;

      return (
        <>
          <h4 style={{ fontSize: 20, color: "#1CB596", textDecoration: "line-through" }}>R$ 200,00 </h4>
          <h4 style={{ fontSize: 20, color: "#1CB596" }}>Desconto aplicado ({desconto}%): {numeral(valor).format("$ 0,0.00")}</h4>
        </>
      )
    }
    return (
      <>
        <p style={{ fontSize: 12 }}>Para você começar as operações fiscais, é necessário <b>ativar sua conta.</b></p>
        <p className="title-span">Taxa de ativação: </p>

        {typeof (AppStore.obs1.usuario.conta.desconto) == "number" && AppStore.obs1.usuario.conta.desconto > 0 ?
          handleGetDesconto()
          :
          <h4 style={{ fontSize: 30, color: "#1CB596" }}>R$ 200,00 </h4>
        }

        <h4 className="title-sec">Escolha a forma de pagamento:</h4>
        <b style={{ fontSize: 12 }}>A forma selecionada será usada também para as futuras mensalidades. Mas não se preocupe, você poderá modificar.</b>
        <br />
        <br />
        <br />
        <p style={{ fontSize: 12, color: "red" }}><b>Atenção:</b> Após realizar o pagamento usando o método Pix ou Cartão, é necessário acessar novamente sua conta para que as devidas alterações sejam aplicadas.</p>

        <RadioGroup
          inline
          onChange={(e) => this.handleChangePagamento(e)}
          selectedValue={this.obs.metodo_pagamento}
        >
          <Radio className="forma" label="Boleto Bancário" value="boleto" />
          <Radio className="forma" label="Cartão de Crédito" value="cartao" />
          <Radio className="forma" label="Pix" value="pix" />
        </RadioGroup>

        {this.obs.metodo_pagamento == 'cartao' &&
          <>
            <MDBCol md="6">
              <b>(Confirmação do pagamento <u>instantânea</u>)</b>
            </MDBCol>

            <br />

            <MDBCol md="12">
              <div style={{ display: "flex" }}>
                &nbsp;&nbsp;
                {!this.obs.loading
                  ? <Button className="btn btn-assinar" onClick={() => this.handleAssinarCartao()}>Assinar</Button>
                  : <Button className="btn btn-assinar">
                    <i className="fa fa-spinner fa-spin"></i>
                    Assinando
                  </Button>
                }
              </div>
            </MDBCol>
          </>
        }
        {this.obs.metodo_pagamento == 'boleto' &&
          <>
            <MDBCol md="6">
              <b>(Confirmação do pagamento em até <u>3 dias úteis </u>)</b>
            </MDBCol>

            <br />

            <MDBCol md="12">
              <div style={{ display: "flex" }}>
                &nbsp;&nbsp;
                {!this.obs.loading
                  ? <Button className="btn btn-assinar" onClick={() => this.handleAssinarBoleto()}>Assinar</Button>
                  : <Button className="btn btn-assinar">
                    <i className="fa fa-spinner fa-spin"></i>
                    Assinando
                  </Button>
                }
              </div>
            </MDBCol>
          </>
        }

        {this.obs.metodo_pagamento == 'pix' &&
          <>
            <MDBCol md="6">
              <b>(Confirmação do pagamento <u>instantânea</u>)</b>
            </MDBCol>

            <br />

            <MDBCol md="12">
              <div style={{ display: "flex" }}>
                &nbsp;&nbsp;
                {!this.obs.loading
                  ? <Button className="btn btn-assinar" onClick={() => this.handleAssinarPix()}>Assinar</Button>
                  : <Button className="btn btn-assinar">
                    <i className="fa fa-spinner fa-spin"></i>
                    Assinando
                  </Button>
                }
              </div>
            </MDBCol>
          </>
        }
      </>
    );
  }
}

export default AssinaturaAtivar;
